import { render, staticRenderFns } from "./Scenes.vue?vue&type=template&id=8a545186&"
import script from "./Scenes.vue?vue&type=script&lang=js&"
export * from "./Scenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports